import React, { Component, } from "react";
import {Router, useHistory } from "react-router-dom";
import { Security } from "@okta/okta-react";
import UserContext from "./components/context/UserContext";
import Routes from "./components/Routes";
import ReactGA from "react-ga";
import ErrorBoundary from "./components/ErrorBoundary";
import { createBrowserHistory } from 'history';
import {pageView} from"./googleAnalyticsHelper";
import CacheBuster from 'react-cache-buster';
import packageJson from "../package.json";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";

// import ReactGA from 'react-ga';
//const oktaAuth = new OktaAuth(config.oidc);

let oktaIssuer = process.env.REACT_APP_OKTA_ISSUER;
  // console.log(oktaIssuer);

  //NOTE: I think we might need to store this somewhere on the deployed environment? Figure this out eventually
  let oktaClientId = process.env.REACT_APP_OKTA_CLIENTID;
  // console.log(oktaClientId);
  const gaTrackingId = process.env.REACT_APP_GA_TRACKING_ID || "G-WM3JGDFMSP";

  const constructedOktaAuth = new OktaAuth({
    issuer: oktaIssuer,
    clientId: oktaClientId,
    // redirectUri: window.location.origin + '/login/callback'
    // redirectUri: "http://localhost:3000/testfile"
    redirectUri: window.location.origin + "/implicit/callback",
  });

const history = createBrowserHistory();

history.listen((location, action) => {
  if(location.state){
    let page = location.state && location.state.name ? location.state.name : (location.pathname + location.search).replaceAll("/", " ");
    pageView(page);
  }else{
    const contentPage = localStorage.getItem("content-page");
    pageView(contentPage);
  }
});

const HasAccessToRouter = () => {
  // example from react-router
  // const history = useHistory(); 

  const customAuthHandler = () => {
    history.push("/login");
  };

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri || "", window.location.origin));
  };

  // const constructedRestoreOriginalUri = async (_oktaAuth, originalUri) => {
  //   navigate(toRelativeUrl(originalUri, window.location.origin), {
  //     replace: true,
  //   });
  // };

  return (
    // <Security
    //   issuer={process.env.REACT_APP_OKTA_ISSUER}
    //   //T1 Version
    //   //client_id="0oask28qpjTOF4Tho0h7"
    //   client_id={process.env.REACT_APP_OKTA_CLIENTID}
    //   redirect_uri={window.location.origin + "/implicit/callback"}
    //   pkce={true}
    //   scopes={["openid", "profile", "email", "groups"]}
    //   onAuthRequired={customAuthHandler}
    // >
    <Security
          oktaAuth={constructedOktaAuth}
          restoreOriginalUri={restoreOriginalUri}
          onAuthRequired={customAuthHandler}
        >
      <Routes />
    </Security>
  );
};


class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentUser: JSON.parse(localStorage.getItem("currentUser")) ?? {},    
        };

        console.log("app constructor - currentUser", this.state.currentUser);
        console.info(
            "UAT build date:",
            new Date(packageJson.buildDate).toLocaleString()
        );
        this.initializeGA();
        //console.log(window.location);
    }

    handleCurrentUserChanged = (user) => {
        console.log("handleCurrentUserChanged", user);
        this.setState({ currentUser: user });
        localStorage.setItem("currentUser", JSON.stringify(user));
    };

    initializeGA = () => {
        ReactGA.initialize(gaTrackingId);
        ReactGA.pageview(window.location.pathname + window.location.search);
        this.initializeGTM();
    };

    initializeGTM = () => {
        if (window.gtagInitialized) {
            return;
        }

        if (typeof document === "undefined") {
            return;
        }

        const existingScript = document.querySelector(
            'script[data-gtag-loader="true"]'
        );
        if (existingScript == null) {
            const script = document.createElement("script");
            script.async = true;
            script.src =
                "https://www.googletagmanager.com/gtag/js?id=" + gaTrackingId;
            script.setAttribute("data-gtag-loader", "true");
            document.head.appendChild(script);
        }

        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag() {
            window.dataLayer.push(arguments);
        };
        window.gtag("js", new Date());
        window.gtag("config", gaTrackingId);
        window.gtagInitialized = true;
    };

  render() {
    return (
      <ErrorBoundary>
        <CacheBuster
          currentVersion={packageJson.version}
          isEnabled={true}
          isVerboseMode={false}
        >
          <UserContext.Provider
            value={{
              currentUser: this.state.currentUser,
              onCurrentUserChanged: this.handleCurrentUserChanged,
            }}
          >
            <Router history={history}>
              <HasAccessToRouter />
            </Router>
          </UserContext.Provider>
        </CacheBuster>
      </ErrorBoundary>
    );
  }
}


export default App;
